import { Product } from "@transfr-inc/dashboard-components/constants";
import { getLearnerTerm } from "@transfr-inc/dashboard-components/constants";

const tsLabels = {
  userTabTitle: `${getLearnerTerm({ plural: true })}`,
  addUser: `Add ${getLearnerTerm()}`,
  singular: `${getLearnerTerm({ lowercase: true })}`,
  plural: `${getLearnerTerm({ lowercase: true, plural: true })}`,
};

const ceLabels = {
  userTabTitle: `${getLearnerTerm({ plural: true })}`,
  addUser: `Add ${getLearnerTerm()}`,
  singular: `${getLearnerTerm({ lowercase: true })}`,
  plural: `${getLearnerTerm({ lowercase: true, plural: true })}`,
};

const labelsMap = new Map();
labelsMap.set(Product.TS, tsLabels);
labelsMap.set(Product.CE, ceLabels);
labelsMap.set(Product.TRK, ceLabels);
labelsMap.set(Product.CE_TRK, ceLabels);
labelsMap.set("TRK_TS", ceLabels);
labelsMap.set(Product.PROG, tsLabels);
labelsMap.set(Product.BASICS, tsLabels);

export const getUserLabelsByProduct = (productId) => labelsMap.get(productId);
